import React from "react";

function importAllPages(r: __WebpackModuleApi.RequireContext) {
  const pages: Record<string, React.ComponentType<any>> = {};
  r.keys().forEach((key) => {
    let componentName = key.replace(/^\.\//, "").replace(/\.\w+$/, "");
    if (componentName.endsWith("/index")) {
      componentName = componentName.replace("/index", "");
    }
    pages[componentName] = r(key).default;
  });
  return pages;
}
export default importAllPages;
